(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["global-popup"] && !Shopify.designMode) return;
  try {
    function findHeaderGlobalPopup(blockId) {
    return Array.from(document.querySelectorAll('[data-global-popup]')).find(
      (modal) => modal.dataset.blockId === blockId
    );
  }

  function initializeHeaderGlobalPopup(template) {
    if (!template) return;

    const existingModal = findHeaderGlobalPopup(template.dataset.blockId);
    if (existingModal) existingModal.remove();

    const modal = template.content.firstElementChild.cloneNode(true);
    const content = modal.querySelector('[data-global-popup-content]');
    const forceDisplayInDesignMode =
      template.dataset.forceDisplayInDesignMode === 'true' && window.Shopify && window.Shopify.designMode;

    document.body.appendChild(modal);
    if (!sessionStorage.getItem('contentPopupShown') || forceDisplayInDesignMode) modal.style.display = 'flex';

    function closePopup() {
      modal.style.display = 'none';
      sessionStorage.setItem('contentPopupShown', 'true');
    }

    modal.querySelectorAll('[data-global-popup-close]').forEach((control) => control.addEventListener('click', closePopup));
    modal.addEventListener('click', (event) => {
      if (!content.contains(event.target)) closePopup();
    });
  }

  function initializeHeaderGlobalPopups(root) {
    root.querySelectorAll('[data-global-popup-template]').forEach(initializeHeaderGlobalPopup);
  }

  function removeHeaderGlobalPopups(root) {
    root.querySelectorAll('[data-global-popup-template]').forEach((template) => {
      const modal = findHeaderGlobalPopup(template.dataset.blockId);
      if (modal) modal.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHeaderGlobalPopups(document));
  } else {
    initializeHeaderGlobalPopups(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeHeaderGlobalPopups(event.target));
  document.addEventListener('shopify:section:unload', (event) => removeHeaderGlobalPopups(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const template = Array.from(document.querySelectorAll('[data-global-popup-template]')).find(
      (item) => item.dataset.blockId === event.detail.blockId
    );
    const modal = template && findHeaderGlobalPopup(template.dataset.blockId);
    if (modal && template.dataset.forceDisplayInDesignMode === 'true') modal.style.display = 'flex';
  });
  } catch(e) { console.error(e); }
})();

})();
